<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="700">
      <v-form ref="ProgramForm" @submit.prevent>
        <v-card>
          <v-card-title
            class="d-flex align-center"
            style="background-color: #2196f3 !important; color: #ffffff"
          >
            <span>{{ action }} Program</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="program_name"
                    :rules="[formRules.required]"
                    label="Program Name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="abbr"
                    :rules="[formRules.required]"
                    label="Program Abbreviation"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    density="compact"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    density="compact"
                    label="Institute"
                    v-model="institute"
                    item-value="id"
                    item-title="name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    chips
                    :items="instituteList"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtns"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="action == 'Add' ? save() : update()"
            >
              <v-icon>mdi-check-circle</v-icon>
              {{ action == "Add" ? "Add" : "Update" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
export default {
  props: {
    data: Object,
    action: String,
  },
  data() {
    return {
      dialog: false,
      btnLoading: false,
      programsList: [],
      instituteList: [],
      institute: null,
      program_name: null,
      abbr: null,
      deletedFile: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        this.initialize();
        this.$refs.ProgramForm.resetValidation();
        if (data.id) {
          this.program_name = data.name;
          this.abbr = data.abbr;
          this.institute = data.institute_id;
        } else {
          this.$refs.ProgramForm.reset();
        }
      },
      deep: true,
    },
  },
  methods: {
    initialize() {
      this.getAllInstitutes();
    },

    async save() {
      let formValid = await this.$refs.ProgramForm.validate();

      if (formValid.valid) {
        this.axiosCall("/program", "POST", {
          name: this.program_name,
          abbr: this.abbr,
          institute_id: this.institute,
        }).then((res) => {
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    async update() {
      let formValid = await this.$refs.ProgramForm.validate();

      if (formValid.valid) {
        this.axiosCall("/program/" + this.data.id, "PATCH", {
          name: this.program_name,
          abbr: this.abbr,
          institute_id: this.institute,
        }).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.btnLoading = false;
            this.closeD();
          } else {
            this.btnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    closeD() {
      eventBus.emit("closeProgramDialog", true);
      this.dialog = false;
    },

    getAllInstitutes() {
      this.axiosCall("/institutes", "GET").then((res) => {
        this.instituteList = res.data;
      });
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
